// Voile "verre givré" posé sur un fond (photo/vidéo) de hero.
// Repris d'un autre projet perso (ai-os-butler/cockpit) et adapté à la
// palette du site : un léger dégradé diagonal façon reflet de vitre
// (sombre → clair → sombre), de minuscules points façon givre/
// condensation, une vignette intérieure, et le grain --grain-svg déjà
// utilisé ailleurs sur le site (pas de texture de bruit dupliquée).
// A poser directement après le fond (image/vidéo + assombrissement),
// avant le contenu — z-index volontairement entre les deux.
//
// Pour le fond uni des pages (pas un hero), voir la classe CSS
// .bg-textured (App.css) posée directement sur la section concernée
// plutôt qu'un calque séparé — un calque position:fixed superposé à
// tout le site se heurtait aux sections qui ont déjà leur propre
// background-color opaque (invisible derrière certaines, visible
// PAR-DESSUS le texte pour d'autres).
const FrostVeil = () => {
  return (
    <div className="absolute inset-0 z-[11] pointer-events-none frost-veil">
      <div className="absolute inset-0 frost-veil__grain" />
    </div>
  );
};

export default FrostVeil;
